<a
  class="no-deco ghost"
  [routerLink]="[expertGroupPortal.baseUrl, 'discussions', discussion.slug]"
>
  <div class="card bg-transparent is-full-height is-relative">
    <img
      [src]="
        discussion.image?.landscapeSmall
          ? discussion.image.landscapeSmall
          : './assets/images/discussion-default-image.png'
      "
      [alt]="discussion.title"
      class="discussion-card__image"
    />
    <div class="foreground"></div>
    <div
      class="card-content is-flex is-align-items-flex-end is-justify-content-space-between is-flex-direction-column is-fullwidth is-full-height"
    >
      <div class="is-fullwidth">
        <h3
          class="title is-4 has-text-white mb-0"
          [innerHTML]="discussion.title"
        ></h3>
        <div
          class="has-text-white is-excerpt"
          [innerHTML]="discussion.excerpt | truncate : [260]"
        ></div>
      </div>
      <div
        class="flex is-align-items-center is-justify-content-space-between is-fullwidth"
      >
        <a class="button is-white is-outlined">
          <span class="icon">
            <i class="fas fa-comment"></i>
          </span>
          <span class=""
            >Participate
            <span class="is-hidden-until-widescreen"
              >to this discussion</span
            ></span
          >
        </a>
      </div>
    </div>
  </div>
</a>
